module.exports = __webpack_public_path__ + "img/keepfrds.e602522e.png";